import {Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {NgRedux, select} from "@angular-redux/store";
import {AdministrationUnit} from "../../../../shared/view-model/organization/administration-unit.type";
import {IAppState} from "../../../../shared/redux-store/store";
import {isUndefined} from "util";
import {Observable} from "rxjs/Observable";
import {IUser} from "../../../../shared/redux-store/session/session.types";
import {IModel} from "../../../../shared/view-model/imodel.interface";

@Injectable()
export class CanEditGuard {

  @select(['session', 'user'])
  private currentUser$: Observable<IUser>;

  currentUser: IUser;

  constructor(private router: Router, private ngRx: NgRedux<IAppState>) {
    this.currentUser$.subscribe(user => this.currentUser = user);
  }

  public canEdit(model: IModel) {
    return model.is_editable;
  }

  private adminUnitAuthorized(adminUnitCuid: string, adminUnits?: AdministrationUnit[]): boolean {

    adminUnits = adminUnits ? adminUnits : (this.currentUser ? this.currentUser.administration_units : []);
    let au = adminUnits.find(au => au.cuid === adminUnitCuid);

    return !isUndefined(au);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/authorization/guards/can-edit.guard.ts